import React, { useState, useEffect } from 'react';
import { Box, Typography, Card, CardContent, Chip } from '@mui/material';
import { getPermissionsGrouped } from '../api';
import type { PermissionsGroupedOut } from '../types';

const PermissionsPage: React.FC = () => {
  const [grouped, setGrouped] = useState<PermissionsGroupedOut[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    getPermissionsGrouped()
      .then((r) => {
        if (!cancelled) setGrouped(r);
      })
      .catch((e) => {
        if (!cancelled) setError(e instanceof Error ? e.message : 'Failed to load');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (loading) return <Typography>Loading...</Typography>;
  if (error) return <Typography color="error">{error}</Typography>;

  return (
    <Box>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Permissions are managed in the backend (seed). Assign them to roles or users in the Roles and Users tabs.
      </Typography>
      {grouped.map((g) => (
        <Card key={g.module} sx={{ mb: 2 }}>
          <CardContent>
            <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 1 }}>
              {g.module}
            </Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
              {g.permissions.map((p) => (
                <Chip key={p.id} label={p.slug} size="small" sx={{ mr: 0.5, mb: 0.5 }} />
              ))}
            </Box>
          </CardContent>
        </Card>
      ))}
    </Box>
  );
};

export default PermissionsPage;
